import { DataActions } from "./constants";
import fetch from "../../utils/fetch";
import { merge, isEmpty } from "lodash";
// import { push } from 'react-router-redux';
import { setApiError, setLoading } from "../../actions/appActions";
import { FilterOperation } from "./dataProvider";

export const dataInit = (dataId, defaultProps) => ({
  type: DataActions.INIT,
  dataId,
  defaultProps,
});

const filtersQuery = (filters) => {
  let g = -1;
  return merge(
    {},
    ...[
      ...(filters != null ? filters : [])
        .filter(({ field }) => field !== null)
        .filter(
          ({ operation, isDate }) =>
            operation !== null && (!isDate || operation !== "EQ"),
        )
        .filter(({ value, operation }) => [FilterOperation.IS_NULL, FilterOperation.NOT_NULL].includes(operation) ||
                                          (!isEmpty(value) && (value?.toString().trim().length > 0))
        )
        .map(({ field, displayField, operation, value, isDate }, i) => {
          if (field.includes('.') && (!displayField || displayField.includes('.'))) {
            const gn = 0;
            const parentField = field.split('.')[0];
            return {
              [`filter[${++g}].field`]: parentField,
              [`filter[${g}].operation`]: "NESTED",
              [`filter[${g}].filter[${gn}].field`]: field,
              [`filter[${g}].filter[${gn}].operation`]: operation,
              [`filter[${g}].filter[${gn}].value`]: value,
            };
          }
          return {
            [`filter[${++g}].field`]: field,
            [`filter[${g}].operation`]: operation,
            [`filter[${g}].value`]: value,
          };
        }),
      ...(filters != null ? filters : [])
        .filter(({ field }) => field !== null)
        .filter(({ operation, isDate }) => isDate && operation === "EQ")
        .filter(({ value }) => !isEmpty(value) && (value?.toString().trim().length > 0))
        .map(({ field, displayField, operation, value }, i) => {
          if (field.includes('.') && (!displayField || displayField.includes('.'))) {
            const gn = 0;
            const parentField = field.split('.')[0];
            return {
              [`filter[${++g}].field`]: parentField,
              [`filter[${g}].operation`]: "NESTED",
              [`filter[${g}].filter[${gn}].field`]: field,
              [`filter[${g}].filter[${gn}].operation`]: "LTE",
              [`filter[${g}].filter[${gn}].value`]: value,
              [`filter[${++g}].field`]: parentField,
              [`filter[${g}].operation`]: "NESTED",
              [`filter[${g}].filter[${gn}].field`]: field,
              [`filter[${g}].filter[${gn}].operation`]: "GTE",
              [`filter[${g}].filter[${gn}].value`]: value,
            };
          }
          return {
            [`filter[${++g}].field`]: field,
            [`filter[${g}].operation`]: "LTE",
            [`filter[${g}].value`]: value,
            [`filter[${++g}].field`]: field,
            [`filter[${g}].operation`]: "GTE",
            [`filter[${g}].value`]: value,
          };
        }),
    ],
  );
};

const sortQuery = (sort, secondarySort, order) => {
  let sortQuery = secondarySort ? { secondarySort } : {};
  return sort !== null && order !== null ? { sort, order, ...sortQuery } : null;
}

const pageQuery = (page, pageSize) =>
  page !== null && pageSize !== null ? { page, pageSize } : null;

const queryQuery = (query) => (!isEmpty(query) ? query : null);

const concatQuery = (...args) =>
  merge({}, ...args.filter((arg) => arg !== null));

const replaceFilterBy = (filters) => {
  return filters.map(filter => {
    if (!filter.filterBy) {
      return { ...filter };
    }

    const { filterBy } = filter;
    const originalValue = filter.value;
    const valueMapping = filterBy.values ? filterBy.values[originalValue] : null;

    const newFilter = {
      ...filter,
      field: valueMapping && valueMapping.field ? valueMapping.field : filterBy.field,
      operation: valueMapping && valueMapping.operation ? valueMapping.operation : filter.operation,
      value: valueMapping ? valueMapping.value : filter.value
    };

    delete newFilter.filterBy;
    return newFilter;
  });
}

export const constructQuery = ({
  query,
  filters,
  sort,
  secondarySort,
  order,
  page,
  pageSize,
}) =>
  concatQuery(
    queryQuery(query),
    filtersQuery(replaceFilterBy(filters)),
    sortQuery(sort, secondarySort, order),
    pageQuery(page, pageSize),
  );

const getErrorDetail = (error) => {
  if (!error) return "Neznámá chyba";
  if (error && error.errors && Array.isArray(error.errors)) {
    return error.errors.join(", ");
  }
  if (error && error.message) return error.message;
  return "Server nevrátil očekávaná data";
};

const parseJsonSafe = async (response) => {
  const raw = await response.text();

  if (!raw || raw.trim() === "") {
    throw new Error("Prázdná odpověď ze serveru");
  }

  try {
    return JSON.parse(raw);
  } catch (e) {
    throw new Error("Neplatná JSON odpověď ze serveru");
  }
};

export const dataLoad = (dataId) => async (dispatch, getState) => {
  const state = getState().grid[dataId];

  const query = constructQuery(state);
  const url = state.url;

  dispatch(setLoading(true, "Načítání dat..."));

  try {
    const response = await fetch(url, dispatch, { params: query });
    const data = await parseJsonSafe(response);
    const { items, count } = Array.isArray(data)
      ? { items: data, count: data.length }
      : data;

    dispatch({
      type: DataActions.LOAD,
      dataId,
      items: Array.isArray(items) ? items : [],
      count: Number.isFinite(count) ? count : 0,
    });

    dispatch(setApiError(null));
  } catch (error) {
    dispatch({
      type: DataActions.LOAD,
      dataId,
      items: [],
      count: 0,
    });

    dispatch(
      setApiError({
        status: 0,
        message: "Nepodařilo se načíst data seznamu",
        detail: getErrorDetail(error),
        url,
      }),
    );
  } finally {
    dispatch(setLoading());
  }
};

export const dataFilterRemove = (dataId, filter) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_REMOVE,
    dataId,
    filter,
  });

  dispatch(dataLoad(dataId));
};

export const dataFilterResetValue = (dataId, filter) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_RESET_VALUE,
    dataId,
    filter,
  });

  dispatch(dataLoad(dataId));
};

export const dataFilterResetValues = (dataId) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_RESET_VALUES,
    dataId,
  });

  dispatch(dataLoad(dataId));
};

export const dataFilterEdit = (dataId, filter, newFilter) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_EDIT,
    dataId,
    filter,
    newFilter,
  });

  // dispatch(dataLoad(dataId));
};

export const dataFilterAdd = (dataId) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_ADD,
    dataId,
  });

  dispatch(dataLoad(dataId));
};

export const dataFilterDefault = (dataId, filters) => (dispatch) => {
  dispatch({
    type: DataActions.FILTER_DEFAULT,
    dataId,
    filters,
  });

  dispatch(dataLoad(dataId));
};

export const dataPageSize = (dataId, pageSize) => (dispatch) => {
  dispatch({
    type: DataActions.PAGE_SIZE,
    dataId,
    pageSize,
  });

  dispatch(dataLoad(dataId));
};

export const dataPage = (dataId, page) => (dispatch) => {
  if(page >= 0) {
    dispatch({
      type: DataActions.PAGE,
      dataId,
      page,
    });
    // dispatch(push({ pathname: window.location.pathname, query: {} }))
    dispatch(dataLoad(dataId));
}
};

export const dataPageNoData = (dataId, page) => (dispatch) => {
  dispatch({
    type: DataActions.PAGE,
    dataId,
    page,
  });
};

export const dataSort = (dataId, sort) => (dispatch) => {
  dispatch({
    type: DataActions.SORT,
    dataId,
    sort,
  });

  dispatch(dataLoad(dataId));
};

export const dataOrder = (dataId, order) => (dispatch) => {
  dispatch({
    type: DataActions.ORDER,
    dataId,
    order,
  });

  dispatch(dataLoad(dataId));
};

export const dataFilterOpen = (dataId, isOpen) => ({
  type: DataActions.FILTER_OPEN,
  dataId,
  isOpen,
});
